import React from 'react';
import { BlueButton } from '@reusejs/react-buttons';
import {
  addHistoricalRatesToProduction,
  addHistoricalRatesToStaging,
  getHistoricalRatesFromProduction,
  getHistoricalRatesFromStaging,
} from '@nx-monorepo/services';

const HistoricalRatesHandler = ({
  payload,
  buttonText = '',
  isGetRates = true,
  disable = false,
  setResponseData = () => {},
}) => {
  const NX_ENVIRONMENT = process.env.NX_ENVIRONMENT.toLowerCase();
  const [stagingBusy, setStagingBusy] = React.useState(false);
  const [productionBusy, setProductionBusy] = React.useState(false);

  const handlePublishingRatesProduction = async () => {
    try {
      setProductionBusy(true);

      if (!isGetRates) {
        const confirmResponse = confirm(
          'Are you sure you want to add these rates to production?'
        );

        if (!confirmResponse) {
          return;
        }
      }

      const response = isGetRates
        ? await getHistoricalRatesFromProduction(payload)
        : await addHistoricalRatesToProduction(payload);

      if (isGetRates) {
        // has we are getting single response from api we are directly getting it
        const currencyPair = Object.keys(response)[0];
        const dateKey = Object.keys(response[currencyPair])[0];
        setResponseData([
          {
            currencyPair: currencyPair,
            data: [response[currencyPair][dateKey]],
          },
        ]);
      }

      if (response && !isGetRates) {
        // handlePublishingRatesStaging(); disabled update in staging
        alert('New Rates Added to Production');
      }
    } catch (error) {
      console.log(
        'Error Adding rates to production Please Trying Again.',
        error
      );
      if (!isGetRates) {
        alert('Error while adding rates to production! Please Trying Again.');
      }
    } finally {
      setProductionBusy(false);
    }
  };

  const handlePublishingRatesStaging = async () => {
    try {
      setStagingBusy(true);
      if (!isGetRates) {
        const confirmResponse = confirm(
          'Are you sure you want to add these rates to staging?'
        );
        if (!confirmResponse) {
          return;
        }
      }
      const response = isGetRates
        ? await getHistoricalRatesFromStaging(payload)
        : await addHistoricalRatesToStaging(payload);

      if (isGetRates) {
        // has we are getting single response from api we are directly getting it
        const currencyPair = Object.keys(response)[0];
        const dateKey = Object.keys(response[currencyPair])[0];
        setResponseData([
          {
            currencyPair: currencyPair,
            data: [response[currencyPair][dateKey]],
          },
        ]);
      }

      if (response && !isGetRates) {
        alert('New Rates Added to Staging');
      }
    } catch (error) {
      console.log('Error Adding rates to staging Please Trying Again.', error);
      if (!isGetRates) {
        alert('Error while adding rates to staging! Please Trying Again.');
      }
    } finally {
      setStagingBusy(false);
    }
  };

  return (
    <div className="z-0 mt-5 mb-5 flex w-full items-center">
      {NX_ENVIRONMENT === 'staging' && (
        <BlueButton
          disable={
            Object.keys(payload).length === 0 || productionBusy || disable
          }
          busy={stagingBusy}
          widthClasses="w-fit ml-4"
          fontClasses="text-sm font-semibold capitalize"
          borderClasses="rounded-lg"
          paddingClasses="px-4 py-3"
          busyText="Processing"
          onClick={handlePublishingRatesStaging}
        >
          {`${buttonText} (Staging)`}
        </BlueButton>
      )}

      {NX_ENVIRONMENT === 'production' && (
        <BlueButton
          disable={Object.keys(payload).length === 0 || stagingBusy || disable}
          busy={productionBusy}
          widthClasses="w-fit ml-4"
          fontClasses="text-sm font-semibold capitalize"
          borderClasses="rounded-lg"
          paddingClasses="px-4 py-3"
          busyText="Processing"
          onClick={handlePublishingRatesProduction}
        >
          {`${buttonText} (Production)`}
        </BlueButton>
      )}
    </div>
  );
};

export default HistoricalRatesHandler;
